import { ReactElement } from 'react';

type ChartTooltipProps = {
  active?: boolean;
  label?: string | number;
  payload?: Array<{ value: number | string } & Record<string, unknown>>;
  showArrow?: boolean;
};

/**
 * Recharts custom tooltip styled like a speech bubble with a bottom triangle.
 */
export default function ChartTooltip({
  active,
  payload,
  showArrow = true
}: ChartTooltipProps): ReactElement | null {
  if (!active || !payload || payload.length === 0) return null;
  const rawValue = payload[0]?.value as number | string | undefined;
  const text = typeof rawValue === 'number' ? rawValue.toLocaleString() : String(rawValue ?? '');

  return (
    <div className="relative">
      <div
        className={`
          relative rounded-2xs bg-secondary-navy-500 text-white
          px-12 py-6 text-body-xs font-bold text-center min-w-49
        `}
      >
        {text}
        {showArrow ? (
          <span
            className="absolute left-1/2 -translate-x-1/2 top-full"
            style={{
              width: 0,
              height: 0,
              borderLeft: '6px solid transparent',
              borderRight: '6px solid transparent',
              borderTop: '8px solid var(--color-secondary-navy-500)'
            }}
          />
        ) : null}
      </div>
    </div>
  );
}
